import api from 'plugin/api';
import { API_URL } from 'types/const';

/**
 * 공지사항 목록 조회
 * @return {Object} 응답 데이터
 */
async function requestList() {
  return api.get(API_URL.sfms.dashboard.notice);
}

export { requestList };
